import React from 'react'
import Form from './component/form'

const StakeHistory = () => <Form />

export default StakeHistory
